import { useEffect, useState } from 'react'
import Layout from './Layout'
import api from '../services/api'

export default function Secretarias() {
  const [secretarias, setSecretarias] = useState([])
  const [expandida, setExpandida] = useState(null)
  const [form, setForm] = useState({ nome:'', sigla:'', responsavel:'' })
  const [formDep, setFormDep] = useState({ nome:'', sigla:'', responsavel:'' })
  const [editando, setEditando] = useState(null)
  const [editandoDep, setEditandoDep] = useState(null)
  const [adicionandoDepEm, setAdicionandoDepEm] = useState(null)
  const [erro, setErro] = useState('')
  const [sucesso, setSucesso] = useState('')

  useEffect(() => { carregar() }, [])

  async function carregar() {
    try {
      const res = await api.get('/secretarias')
      const todas = res.data
      const raiz = todas.filter(s => !s.pai_id)
      const comDeps = raiz.map(s => ({
        ...s,
        departamentos: todas.filter(d => d.pai_id === s.id)
      }))
      setSecretarias(comDeps)
    } catch {}
  }

  const set = (k,v) => setForm(f => ({...f,[k]:v}))
  const setDep = (k,v) => setFormDep(f => ({...f,[k]:v}))

  async function salvarSecretaria() {
    if (!form.nome) { setErro('Nome é obrigatório'); return }
    setErro('')
    try {
      if (editando) { await api.put(`/secretarias/${editando}`, form); setSucesso('Secretaria atualizada!') }
      else { await api.post('/secretarias', form); setSucesso('Secretaria criada!') }
      setForm({ nome:'', sigla:'', responsavel:'' }); setEditando(null)
      carregar(); setTimeout(() => setSucesso(''), 3000)
    } catch(e) { setErro(e.response?.data?.erro || 'Erro ao salvar') }
  }

  async function salvarDepartamento(secretaria_id) {
    if (!formDep.nome) { setErro('Nome do departamento é obrigatório'); return }
    setErro('')
    try {
      if (editandoDep) { await api.put(`/secretarias/${editandoDep}`, { ...formDep, pai_id: secretaria_id }); setSucesso('Departamento atualizado!') }
      else { await api.post('/secretarias', { ...formDep, pai_id: secretaria_id }); setSucesso('Departamento criado!') }
      setFormDep({ nome:'', sigla:'', responsavel:'' }); setAdicionandoDepEm(null); setEditandoDep(null)
      carregar(); setTimeout(() => setSucesso(''), 3000)
    } catch(e) { setErro(e.response?.data?.erro || 'Erro ao salvar departamento') }
  }

  function editarSecretaria(s) {
    setEditando(s.id); setForm({ nome:s.nome, sigla:s.sigla||'', responsavel:s.responsavel||'' }); window.scrollTo(0,0)
  }

  function editarDepartamento(d, sec_id) {
    setEditandoDep(d.id); setAdicionandoDepEm(sec_id); setFormDep({ nome:d.nome, sigla:d.sigla||'', responsavel:d.responsavel||'' })
  }

  async function remover(id) {
    if (!window.confirm('Remover? Os departamentos vinculados também serão removidos.')) return
    try { await api.delete(`/secretarias/${id}`); carregar() } catch {}
  }

  const inp = (val, onChange, placeholder) => (
    <input value={val} onChange={onChange} placeholder={placeholder}
      style={{ width:'100%', padding:'8px 10px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, boxSizing:'border-box' }} />
  )

  return (
    <Layout>
      <h1 style={{ fontSize:18, fontWeight:500, margin:'0 0 8px' }}>Secretarias e departamentos</h1>
      <div style={{ fontSize:13, color:'#9ca3af', marginBottom:24 }}>
        Cadastre as secretarias e vincule os departamentos a cada uma.
      </div>

      {sucesso && <div style={{ background:'#f0fdf4', border:'1px solid #bbf7d0', borderRadius:8, padding:12, fontSize:13, color:'#15803d', marginBottom:16 }}>{sucesso}</div>}

      <div style={{ display:'grid', gridTemplateColumns:'320px 1fr', gap:20 }}>

        <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:20, alignSelf:'start' }}>
          <div style={{ fontSize:14, fontWeight:500, marginBottom:16 }}>{editando ? 'Editar secretaria' : 'Nova secretaria'}</div>
          <div style={{ marginBottom:12 }}>
            <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:4, color:'#374151' }}>Nome *</label>
            {inp(form.nome, e=>set('nome',e.target.value), 'Ex: Secretaria de Obras')}
          </div>
          <div style={{ marginBottom:12 }}>
            <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:4, color:'#374151' }}>Sigla</label>
            {inp(form.sigla, e=>set('sigla',e.target.value), 'Ex: SEOB')}
          </div>
          <div style={{ marginBottom:16 }}>
            <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:4, color:'#374151' }}>Responsável / Secretário(a)</label>
            {inp(form.responsavel, e=>set('responsavel',e.target.value), 'Nome do secretário(a)')}
          </div>
          {erro && <div style={{ background:'#fef2f2', border:'1px solid #fecaca', borderRadius:8, padding:10, fontSize:12, color:'#dc2626', marginBottom:10 }}>{erro}</div>}
          <div style={{ display:'flex', gap:8 }}>
            <button onClick={salvarSecretaria} style={{ flex:1, padding:9, background:'#185FA5', color:'white', border:'none', borderRadius:8, fontSize:13, cursor:'pointer', fontWeight:500 }}>
              {editando ? 'Salvar' : 'Criar secretaria'}
            </button>
            {editando && (
              <button onClick={() => { setEditando(null); setForm({ nome:'', sigla:'', responsavel:'' }) }}
                style={{ padding:'9px 12px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, cursor:'pointer', background:'white' }}>✕</button>
            )}
          </div>
        </div>

        <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
          {secretarias.length === 0
            ? <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:40, textAlign:'center', color:'#9ca3af', fontSize:14 }}>
                Nenhuma secretaria cadastrada. Crie a primeira ao lado.
              </div>
            : secretarias.map(sec => (
              <div key={sec.id} style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', overflow:'hidden' }}>
                <div style={{ display:'flex', alignItems:'center', gap:12, padding:'14px 20px', borderBottom: expandida===sec.id?'1px solid #f3f4f6':'none' }}>
                  <div style={{ width:40, height:40, borderRadius:8, background:'#E6F1FB', display:'flex', alignItems:'center', justifyContent:'center', fontSize:13, fontWeight:700, color:'#185FA5', flexShrink:0 }}>
                    {sec.sigla ? sec.sigla.substring(0,3) : sec.nome.substring(0,2).toUpperCase()}
                  </div>
                  <div style={{ flex:1 }}>
                    <div style={{ fontSize:14, fontWeight:500 }}>{sec.nome}</div>
                    <div style={{ fontSize:12, color:'#9ca3af', marginTop:1 }}>
                      {sec.responsavel ? `${sec.responsavel} · ` : ''}
                      {sec.departamentos.length} departamento{sec.departamentos.length!==1?'s':''}
                    </div>
                  </div>
                  <div style={{ display:'flex', gap:6 }}>
                    <button onClick={() => setExpandida(expandida===sec.id?null:sec.id)}
                      style={{ padding:'5px 12px', border:'1px solid #d1d5db', borderRadius:6, fontSize:12, cursor:'pointer', background: expandida===sec.id?'#E6F1FB':'white', color: expandida===sec.id?'#185FA5':'#374151' }}>
                      {expandida===sec.id ? '▲ Recolher' : '▼ Departamentos'}
                    </button>
                    <button onClick={() => editarSecretaria(sec)}
                      style={{ padding:'5px 10px', border:'1px solid #d1d5db', borderRadius:6, fontSize:12, cursor:'pointer', background:'white' }}>Editar</button>
                    <button onClick={() => remover(sec.id)}
                      style={{ padding:'5px 10px', border:'1px solid #fecaca', borderRadius:6, fontSize:12, cursor:'pointer', background:'white', color:'#dc2626' }}>Remover</button>
                  </div>
                </div>

                {expandida === sec.id && (
                  <div style={{ padding:'12px 20px 16px' }}>
                    {sec.departamentos.length === 0 && !adicionandoDepEm &&
                      <div style={{ fontSize:13, color:'#9ca3af', padding:'4px 0 8px' }}>Nenhum departamento cadastrado ainda.</div>
                    }
                    {sec.departamentos.map(dep => (
                      <div key={dep.id}>
                        {editandoDep === dep.id ? (
                          <div style={{ background:'#f0f7ff', border:'1px solid #B5D4F4', borderRadius:8, padding:12, marginBottom:8 }}>
                            <div style={{ fontSize:12, fontWeight:500, color:'#185FA5', marginBottom:8 }}>Editando departamento</div>
                            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8, marginBottom:8 }}>
                              <div>
                                <label style={{ display:'block', fontSize:11, fontWeight:500, marginBottom:3, color:'#374151' }}>Nome *</label>
                                {inp(formDep.nome, e=>setDep('nome',e.target.value), 'Nome do departamento')}
                              </div>
                              <div>
                                <label style={{ display:'block', fontSize:11, fontWeight:500, marginBottom:3, color:'#374151' }}>Sigla</label>
                                {inp(formDep.sigla, e=>setDep('sigla',e.target.value), 'Ex: DEP')}
                              </div>
                            </div>
                            <div style={{ marginBottom:8 }}>
                              <label style={{ display:'block', fontSize:11, fontWeight:500, marginBottom:3, color:'#374151' }}>Responsável</label>
                              {inp(formDep.responsavel, e=>setDep('responsavel',e.target.value), 'Nome do responsável')}
                            </div>
                            <div style={{ display:'flex', gap:6 }}>
                              <button onClick={() => salvarDepartamento(sec.id)}
                                style={{ padding:'6px 14px', background:'#185FA5', color:'white', border:'none', borderRadius:6, fontSize:12, cursor:'pointer' }}>Salvar</button>
                              <button onClick={() => { setEditandoDep(null); setAdicionandoDepEm(null); setFormDep({ nome:'', sigla:'', responsavel:'' }) }}
                                style={{ padding:'6px 10px', border:'1px solid #d1d5db', borderRadius:6, fontSize:12, cursor:'pointer', background:'white' }}>Cancelar</button>
                            </div>
                          </div>
                        ) : (
                          <div style={{ display:'flex', alignItems:'center', gap:10, padding:'8px 10px', borderRadius:8, marginBottom:4, cursor:'default' }}
                            onMouseEnter={e=>e.currentTarget.style.background='#f9fafb'}
                            onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
                            <div style={{ width:6, height:6, borderRadius:'50%', background:'#185FA5', flexShrink:0, marginLeft:8 }} />
                            <div style={{ flex:1 }}>
                              <span style={{ fontSize:13, fontWeight:500 }}>{dep.nome}</span>
                              {dep.sigla && <span style={{ fontSize:11, color:'#9ca3af', marginLeft:6 }}>({dep.sigla})</span>}
                              {dep.responsavel && <div style={{ fontSize:11, color:'#9ca3af' }}>{dep.responsavel}</div>}
                            </div>
                            <div style={{ display:'flex', gap:4 }}>
                              <button onClick={() => editarDepartamento(dep, sec.id)}
                                style={{ padding:'3px 8px', border:'1px solid #d1d5db', borderRadius:6, fontSize:11, cursor:'pointer', background:'white' }}>Editar</button>
                              <button onClick={() => remover(dep.id)}
                                style={{ padding:'3px 8px', border:'1px solid #fecaca', borderRadius:6, fontSize:11, cursor:'pointer', background:'white', color:'#dc2626' }}>Remover</button>
                            </div>
                          </div>
                        )}
                      </div>
                    ))}

                    {adicionandoDepEm === sec.id && !editandoDep ? (
                      <div style={{ background:'#f0f7ff', border:'1px solid #B5D4F4', borderRadius:8, padding:12, marginTop:8 }}>
                        <div style={{ fontSize:12, fontWeight:500, color:'#185FA5', marginBottom:8 }}>Novo departamento em {sec.nome}</div>
                        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8, marginBottom:8 }}>
                          <div>
                            <label style={{ display:'block', fontSize:11, fontWeight:500, marginBottom:3, color:'#374151' }}>Nome *</label>
                            {inp(formDep.nome, e=>setDep('nome',e.target.value), 'Ex: Depto. de Iluminação')}
                          </div>
                          <div>
                            <label style={{ display:'block', fontSize:11, fontWeight:500, marginBottom:3, color:'#374151' }}>Sigla</label>
                            {inp(formDep.sigla, e=>setDep('sigla',e.target.value), 'Ex: DEIL')}
                          </div>
                        </div>
                        <div style={{ marginBottom:8 }}>
                          <label style={{ display:'block', fontSize:11, fontWeight:500, marginBottom:3, color:'#374151' }}>Responsável</label>
                          {inp(formDep.responsavel, e=>setDep('responsavel',e.target.value), 'Nome do responsável')}
                        </div>
                        <div style={{ display:'flex', gap:6 }}>
                          <button onClick={() => salvarDepartamento(sec.id)}
                            style={{ padding:'6px 14px', background:'#185FA5', color:'white', border:'none', borderRadius:6, fontSize:12, cursor:'pointer', fontWeight:500 }}>
                            Criar departamento
                          </button>
                          <button onClick={() => { setAdicionandoDepEm(null); setFormDep({ nome:'', sigla:'', responsavel:'' }) }}
                            style={{ padding:'6px 10px', border:'1px solid #d1d5db', borderRadius:6, fontSize:12, cursor:'pointer', background:'white' }}>Cancelar</button>
                        </div>
                      </div>
                    ) : (
                      !editandoDep && (
                        <button onClick={() => { setAdicionandoDepEm(sec.id); setFormDep({ nome:'', sigla:'', responsavel:'' }) }}
                          style={{ marginTop:8, padding:'7px 14px', border:'1.5px dashed #B5D4F4', borderRadius:8, fontSize:12, cursor:'pointer', background:'#f0f7ff', color:'#185FA5', width:'100%', fontWeight:500 }}>
                          + Adicionar departamento
                        </button>
                      )
                    )}
                  </div>
                )}
              </div>
            ))
          }
        </div>
      </div>
    </Layout>
  )
}
